import React, { useState } from "react";
import PropTypes from "prop-types";

import { Tooltip } from "../Tooltip/Tooltip";

import { CurrentAsscessoryImage as _CurrentAsscessoryImage } from "./style";

// Default imports will generate a smaller bundle size
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const Dropdown = ({
  label,
  values,
  defaultValue = "",
  onChange,
  tooltipContent,
  disabled = false,
  image,
}) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <Box md={4} sx={{ display: "flex", flex: 1, flexDirection: "column", maxWidth: '400px' }}>
      <FormControl fullWidth size="small">
          <FormLabel
            id={`${values.toString()}-label`}
            sx={{
              fontSize: "16px",
              fontWeight: "bold",
              display: "inlineBlock",
              fontFamily: "aktiv-grotesk, sans-serif",
              paddingTop: "24px",
              marginBottom: "4px",
              color: "#000000",
              paddingTop: "15px",
              "&.Mui-focused": {
                color: "#111111",
              },
            }}
          >
            {label}
            {tooltipContent && (
              <Tooltip
                content={tooltipContent}
                dataId={`RadioList__${name}_Tooltip`}
              />
            )}
          </FormLabel>

        {image && (
          // TODO layout for this img
          <_CurrentAsscessoryImage
            src={image.imgSrc}
            alt={image.imgAlt || ""}
          />
        )}

        <Select
          labelId={label}
          id={label}
          name={label}
          value={value}
          defaultValue={value}
          onChange={(e) => handleChange(e)}
          size="small"
          displayEmpty
          disabled={disabled}
          sx={{
            fontSize: "14px",
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#111111",
            },
            "@media (min-width: 768px)": {
              fontSize: "16px",
            },
          }}
        >
          {values.map((option) => {
            return (
              <MenuItem
                key={`${option.label}__${option.value}`}
                value={option.value}
                sx={{
                  fontSize: "14px",
                  minHeight: "36px",
                  "@media (min-width: 768px)": {
                    fontSize: "16px",
                    minHeight: "48px",
                  },
                }}
              >
                <span>
                  {option.label
                    ? option.cost
                      ? `${option.label}, `
                      : option.label
                    : ""}
                </span>

                <b>&nbsp;{option.cost && option.cost}</b>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

Dropdown.propTypes = {
  label: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.object),
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  tooltipContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  disabled: PropTypes.bool,
  image: PropTypes.shape({
    imgSrc: PropTypes.string,
    imgAlt: PropTypes.string,
  }),
};

export default Dropdown;
